import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import { Portal } from '@/components-latest/primitives/SplashScreen/SplashScreen'
import ErrorState from '@/components-latest/shared/ErrorState'
import { selectBootStatus } from '@/ducks/app/selectors/app.selectors'
import { startInitialization } from '@/ducks/app/slices/app.shared'

import Styles from './BootErrorScreen.module.scss'

/**
 * Replaces the splash screen when the boot chain fails, so a dropped request
 * during cold start can be retried instead of leaving a data-less shell.
 */
const BootErrorScreen = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const bootStatus = useSelector(selectBootStatus)

  return (
    <Portal>
      <div className={Styles.container} data-testid="boot-error-screen">
        <div className={Styles.logoWrapper}>
          <img
            width="255"
            src="/images/yassir-express-text-logo.svg"
            alt="Yassir Express"
          />
        </div>
        <ErrorState
          data-testid="boot-error"
          title={t('boot.error.title')}
          description={t('boot.error.description')}
          isRetrying={bootStatus === 'loading'}
          onRetry={() => dispatch(startInitialization())}
        />
      </div>
    </Portal>
  )
}

export default BootErrorScreen
